<template>
  <v-btn @click="$emit('click', $event)" color="green" dark :loading="loadingProductCreation">
    <span
      class="mr-2"
    >{{ selectedItems.length ? `Crear QMP con ${selectedItemsLength + 1} QMIs` : `Crear QMP solo con pivote`}}</span>
    <v-icon>check</v-icon>
  </v-btn>
</template>

<script>
import { createNamespacedHelpers } from "vuex";
const { mapState } = createNamespacedHelpers("matching");

export default {
  computed: {
    ...mapState(["loadingProductCreation", "selectedItems"]),
    selectedItemsLength() {
      let totalItemsLength = 0;
      let itemsLength = this.selectedItems.length;
      this.selectedItems.forEach(item => {
        if (item.homologedItems) {
          totalItemsLength += item.homologedItems.length;
        }
      });
      totalItemsLength += itemsLength;

      return totalItemsLength;
    }
  }
};
</script>